import { Inject, Injectable, inject } from '@angular/core';
import { BaseResponse } from '../models';
import { ApiUrls } from '../backoffice-urls';
import { Environment, EnvConfig } from '@doc/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment
  ) 
  {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  createFaq(body:any){
    const link = this.apiUrl + ApiUrls.insertFaq;
    return this.http.post<BaseResponse>(link, body);
  }

  updateFaq(body:any){
    const link = this.apiUrl + ApiUrls.updateFaq;
    return this.http.post<BaseResponse>(link, body);
  }

  deleteFaq(body:any){
    const link = this.apiUrl + ApiUrls.deleteFaq;
    return this.http.post<BaseResponse>(link, body);
  }

  getFaqById(id:any){
    const link = this.apiUrl + ApiUrls.getFaqById + '/'+ id;
    return this.http.get<BaseResponse>(link);
  }
  
  getFaqList(body:any){
    const link = this.apiUrl + ApiUrls.getFaqList;
    return this.http.post<BaseResponse>(link, body);
  }


}
